var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrowelAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86637 15.1469L2.06626 4.45104C1.76007 3.58925 2.56825 2.75121 3.39931 3.06871L13.7139 7.00929C14.4249 7.2809 14.6249 8.22515 14.0891 8.78069L11.867 11.085L13.5961 11.574C13.8705 11.6516 14.1206 11.8021 14.3217 12.0107L15.5844 13.32L15.8232 13.0724C16.2286 12.652 16.8859 12.652 17.2914 13.0724L21.6959 17.6398C22.1014 18.0602 22.1014 18.7418 21.6959 19.1622L20.2277 20.6847C19.8223 21.1051 19.165 21.1051 18.7595 20.6847L14.355 16.1173C13.9495 15.6969 13.9495 15.0153 14.355 14.5948L14.5938 14.3472L13.3311 13.0379C13.3024 13.0081 13.2667 12.9866 13.2275 12.9755L10.726 12.2681L7.57463 15.536C7.03889 16.0915 6.1283 15.8841 5.86637 15.1469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrowelAlt1);
export default __webpack_public_path__ + "static/media/trowel-alt-1.1c57fcab3bc50852e0c60ce348689acd.svg";
export { ForwardRef as ReactComponent };